import { useInfiniteQuery } from '@tanstack/react-query';
import { getThemeImportQuestions } from '@/api/theme-import-history.api';
import type { ThemeImportStatusFilter } from '@/api/theme-import-history.api';

const PAGE_SIZE = 100;

export function useThemeImportQuestions(themeId: string | null, isOpen: boolean, status: ThemeImportStatusFilter = 'active') {
  return useInfiniteQuery({
    queryKey: ['theme-import-questions', themeId, status],
    queryFn: ({ pageParam }) =>
      getThemeImportQuestions(themeId ?? '', { page: pageParam, limit: PAGE_SIZE, status }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.pagination.has_more
        ? lastPage.meta.pagination.page + 1
        : undefined,
    enabled: isOpen && themeId !== null,
  });
}
